export { SwatchGroup as default } from './SwatchGroup'
